import * as React from 'react';
import { Header3 } from '@cian/ui-kit';
import { ArrowR16 } from '@cian/ui-kit/icons';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  imgUrl?: string;
}

export function AdvantageItem({ title, imgUrl }: IAdvantageItemProps) {
  const [hovered, setHovered] = React.useState(false);

  const changeHovered = React.useCallback(() => setHovered(!hovered), [hovered]);

  return (
    <div
      className={styles['container']}
      style={{ backgroundImage: `url(${imgUrl})` }}
      onMouseOver={changeHovered}
      onMouseOut={changeHovered}
    >
      <div className={styles['title']}>
        <Header3 as="h3" color="white_100">
          {title}
        </Header3>
      </div>
      <div className={classNames(styles['arrow'], hovered && styles['arrow-hovered'])}>
        <div className={styles['icon_container']}>
          <ArrowR16 color={'white_100'} />
        </div>
      </div>
    </div>
  );
}
